export const WageImprovement = {
  None: 0, // なし
  Both: 1, // （Ⅰ）・（Ⅱ）継続あり
  OneOnly: 2 // （Ⅰ）のみ継続あり
} as const;

export type WageImprovementType = typeof WageImprovement[keyof typeof WageImprovement];
